var map = {
	"./1.jpg": "./src/images/gallery/Machine Learning Workshop/1.jpg",
	"./2.jpg": "./src/images/gallery/Machine Learning Workshop/2.jpg",
	"./3.jpg": "./src/images/gallery/Machine Learning Workshop/3.jpg",
	"./4.jpg": "./src/images/gallery/Machine Learning Workshop/4.jpg",
	"./5.jpg": "./src/images/gallery/Machine Learning Workshop/5.jpg",
	"./6.jpg": "./src/images/gallery/Machine Learning Workshop/6.jpg",
	"./cover.jpg": "./src/images/gallery/Machine Learning Workshop/cover.jpg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/images/gallery/Machine Learning Workshop sync \\.(png%7Cjpe?g%7Csvg)$";